<template>
  <div class="chat">
    <div class="mainChat" id="chatbox">
      <div
        v-for="item in SubCat"
        :key="item.index"
        :class="[
          item.ticket_owner !== 1 ? 'receiveTextMessage' : 'sendTextMessage',
          'textMessage',
        ]"
      >
        <div class="nameapp">
          <span>{{item.ticket_title}}</span>
        </div>
        <div class="textMessages textapp">
          <span> {{ item.ticket_description }} </span>
        </div>
        <div class="timeDate">
          <span>{{ item.date }}</span>
        </div>
      </div>
    </div>
    <form class="addChat">
      <v-textarea
        rows="1"
        hide-details
        no-resize
        class="inputChat"
        placeholder="نوشتن متن"
        height="70px"
        auto-grow
        row-height="7"
        dense
        v-model="ChatText"
      ></v-textarea>
      <v-btn
        height="70"
        class="sendMessage"
        color="transparent"
        @click="SendChat"
      >
        <v-icon>send</v-icon>
      </v-btn>
    </form>
  </div>
</template>
<script>
import oracle from "@/oracle";
import { getBeautifyDate } from "@/utils/getBeautifyDate";
export default {
  name: "chat",
  data() {
    return {
      SubCat: "",
      userdialog: false,
      ChatText: "",
      consult_id: "",
      avatar: "",
      flag: "",
    };
  },
  methods: {
    loadData() {
      const id = this.$route.query.id;
      oracle.axios(
        "ticket/getAll",
        { limit_by: 500, offset_by: 0, parent_by: id },
        this.GetAllChat
      );
    },
    GetAllChat(res) {
      console.log(res)
      let data = [];
      res.data.forEach((element) => {
        data.push({
          date: getBeautifyDate(element.create_at),
          ...element,
        });
      });
      this.SubCat = data.reverse();
    },
    SendChat() {
      const id = this.$route.query.id;
      const model = {
        parent_id: id,
        ticket_description: this.ChatText,
      };
      oracle.axios("ticket/create", model, this.handleSend);
    },
    handleSend(res) {
      this.loadData();
      this.ChatText = "";
    },
  },
  mounted() {
    const id = this.$route.query.id;
    this.loadData();
    oracle.axios("ticket/readAll", { ticket_id: id }, null);
  },
  created() {
    document.title = "چت";
  },
};
</script>
<style>
.imgsize {
  width: 70%;
  height: auto;
  object-fit: cover;
}
.voicesize {
  width: 100% !important;
  height: unset !important;
  overflow: hidden;
  padding: 0 !important;
  margin: 0 !important;
  margin-top: 1em !important;
}
.headerSearch,
.listshowinfo {
  padding: 0 !important;
}

.headerSearch
  .theme--light.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  background: transparent !important;
  box-shadow: none;
}

.dialogshowinfo {
  transform: translateY(-2vh);
  overflow: auto;
}

.listPrograms,
.listDetailCategory {
  width: 100%;
}

.listshowinfo {
  height: 80%;
  overflow: auto;
}
.listshowinfo ul {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;
}
.listshowinfo ul li {
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.listshowinfo ul li span {
  padding: 5px 0;
}
.listshowinfo {
  border-bottom: 1px solid #707070;
}
.listPrograms li,
.listDetailCategory li {
  padding: 1em;
  border-bottom: 1px solid #c0c0c0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.listDetailCategory li p {
  margin: 0;
  font-weight: 900;
  font-size: 12px;
  color: #000;
}

.listDetailCategory li span {
  font-size: 12px;
}

.headerSearch input {
  font-size: 12px;
}

.closeModal,
.closeModalinfo {
  display: flex;
  justify-content: flex-end;
}

.chat {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 65px;
}

.mainChat {
  height: 100%;
  background-image: url("../../assets/image/catstile.png");
  background-size: cover;
  padding: 15px 25px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.addChat {
  display: flex;
  align-items: flex-start;
  background: #fff;
  max-height: 200px;
  overflow: hidden;
}

.inputChat {
  margin: 0;
  padding: 0;
  margin-right: 15px;
}

.inputChat .v-input__control > .v-input__slot:before {
  border-color: transparent !important;
}

.inputChat .v-input__control > .v-input__slot:after {
  border-color: transparent !important;
}

.sendMessage,
.senduserpic {
  box-shadow: none;
  position: sticky;
  top: 0;
}

.sendMessage i {
  color: #0000cd !important;
  transform: rotate(180deg);
}

.senduserpic i {
  color: #707070 !important;
}

.inputChat .v-text-field__slot {
  max-height: 100%;
}

.textMessage {
  width: 90%;
  padding: 10px 8px;
  border-radius: 15px;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between;
  position: relative;
  margin-bottom: 1em;
  align-self: flex-start;
  text-align: right;
}
.textMessage img {
  width: 100%;
  height: 100%;
}

.sendTextMessage {
  background: #fff;
  margin-left: auto;
}
.sendTextMessage .timeDate {
  padding-top: 10px;
  text-align: left;
}
.sendTextMessage::after {
  content: "";
  position: absolute;
  right: -20px;
  top: 0;
  width: 0;
  height: 0;
  border-top: 0px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 30px solid #ffffff;
}

.receiveTextMessage {
  background: #fba800;
  margin-right: auto;
  color: #fff;
}
.receiveTextMessage .timeDate span {
  color: #707070;
}
.receiveTextMessage::after {
  content: "";
  position: absolute;
  left: -20px;
  top: 0;
  width: 0;
  height: 0;
  border-top: 0px solid transparent;
  border-bottom: 20px solid transparent;
  border-right: 30px solid #fba800;
}

.timeDate span {
  font-size: 12px;
  color: #949494;
}

.textMessages span {
  font-size: 11px;
  padding: 0 10px;
  text-align: right;
}
.textapp {
  color: #0000cd;
}
.headslineSetting {
  display: flex;
  justify-content: space-between;
}

.headslineSetting span:first-child {
  font-size: 13px;
  color: #000;
  font-weight: bold;
}

.removeFilters span {
  color: #aeaeb6 !important;
  font-size: 10px !important;
  text-align: center;
  font-weight: 100 !important;
}

.removeFilters .v-icon {
  font-size: 20px;
}

.removeFilters {
  display: flex;
}

.titlesModal {
  padding: 10px 15px;
  display: flex;
  align-items: center;
}
.titlesModal h6 {
  color: #011d33;
  font-size: 14px;
}
.titlesModal span {
  color: #aeaeb6;
  font-size: 12px;
  width: 100%;
}
.img-titlesModal {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #fff;
  box-shadow: 0 3px 10px -5px #000;
}
.img-titlesModal img {
  width: 100%;
  height: 100%;
}
.text-titlesModal {
  padding: 0 10px;
}
.box-titlesModal {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.see-more-profile {
  color: #011d33;
  font-size: 11px;
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}
.see-more-profile .v-icon {
  font-size: 15px;
  color: #011d33;
}
.btn-supplement,
.btn-voice,
.btn-Foods,
.btn-sports {
  width: 100%;
  display: flex;
  padding: 5px;
  justify-content: space-between;
}
.content-supplement,
.content-voice,
.content-Foods,
.content-sports {
  background: #fff;
  padding: 10px;
  width: 100px;
  text-align: center;
}
.content-supplement span,
.content-voice span,
.content-Foods span,
.content-sports span {
  color: #011d33;
  font-size: 12px;
}
.text-btn-supplement,
.text-btn-voice,
.text-btn-Foods,
.text-btn-sport {
  display: flex;
  align-items: center;
  margin: 0 auto;
}
.text-btn-supplement .v-icon,
.text-btn-voice .v-icon,
.text-btn-Foods .v-icon,
.text-btn-sport .v-icon {
  color: #fff;
  font-size: 16px;
}
.text-btn-supplement span,
.text-btn-voice span,
.text-btn-Foods span,
.text-btn-sport span {
  font-size: 12px;
  color: #fff;
}
.btn-supplement {
  background: #ffdb02;
}
.btn-voice {
  background: red;
}
.btn-Foods {
  background: green;
}
.btn-sports {
  background: #3498db;
}
.v-card .selectpics {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px !important;
  color: #000 !important;
  font-weight: bold;
}

.selectpics span {
  color: #707070 !important;
  font-size: 13px;
}

.btnSendPics {
  display: flex;
  justify-content: space-between;
}

.btnSendPics .v-btn {
  width: 100px;
  height: 30px;
  border-radius: 10px;
}
.nameapp {
  color: #fff;
  font-size: 12px;
}
.btnSendPics .camera {
  background: #ffdb02;
  width: 70px;
  height: 35px;
  border-radius: 5px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-left: 10px;
}

.btnSendPics .galleris {
  background: #fff;
  box-shadow: 0 0 3px -1px #707070;
  width: 70px;
  height: 35px;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 12px;
}

#btnsCamera {
  width: 0;
  height: 0;
  opacity: 0;
}

.closemodals {
  font-size: 12px;
  color: #707070;
}

.picselect,
.btnsOpeanCamera {
  display: flex;
  align-items: center;
}

.v-dialog {
  box-shadow: none !important;
}

.chatItem {
  width: 80%;
}
.sender {
  margin-right: auto;
}
@media only screen and (max-width: 360px) {
  .chat {
    height: calc(100vh - 50px);
  }
  .nameapp span {
    font-size: 12px;
  }
}
</style>
